<template>
    <div class="container">
        <h1>Enter passcode</h1>
        <div class="inputrow">
            <input type="password" id="surveycode" />
            <button @click="submit()">
                <h2>Go</h2>
            </button>
        </div>
        <h5 id="errortext">Invalid passcode, please try again</h5>
    </div>
</template>

<script>
import accountStore from "../accountStore";
import axios from "axios";
import { baseurl } from "../api";

export default {
    methods: {
        submit() {
            const inputobj = document.getElementById("surveycode");
            const usercode = inputobj.value;

            axios.post(baseurl + "checkpasscode", { code: usercode }).then((r) => {
                if (r.data.success) {
                    accountStore.login(usercode);
                    this.$router.push("/manage");
                    return;
                }
                accountStore.logout();
                inputobj.classList.add("errored");
                document.getElementById("errortext").classList.add("shown");
            });
        },
    },
    created() {
        window.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                this.submit();
            }
        });
    },
    name: "Admin",
};
</script>

<style scoped>
.container {
    margin-bottom: 2rem;
}

input {
    border: 1px solid #555555;
    border-radius: 1rem;
    padding: 1rem 1rem;
    margin: 0 1rem;
    font-size: 1rem;
    font-weight: bold;
    height: 100%;
}

.errored {
    border: 1px solid #ff0000;
}

.errored:focus {
    outline-color: #ff0000;
}

button {
    background-color: #007bff;
    border: none;
    border-radius: 1rem;
    cursor: pointer;
}

button>h2 {
    color: #ffffff;
    margin: 0.8rem 1rem;
}

.inputrow {
    display: flex;
    align-items: center;
}

h5 {
    text-align: left;
    margin: 0.3rem 1.7rem;
    color: #c70000;
    visibility: hidden;
}

.shown {
    visibility: visible;
}
</style>
